<template>
  <div id="app">
  </div>  
</template>

<script>
export default 
{
  name: "App",
  data() 
  {
    // `this` points to the vm instance 
    return {
      value: "World"
    };
  },
  
  created: function () {
    // `this` points to the vm instance
  },

  async mounted() {
    console.log('App.vue: mounted() called, running HTTP fetch...')
    const text = await (await fetch("/api/HttpTrigger_HelloWorld")).json()
    console.log('App.vue: mounted(), fetch returned:' + text)
    this.value = text
  }
};
</script>
